var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Admin Skills","fields":_vm.fields,"response":_vm.data,"working_th_searches":_vm.working_th_searches},on:{"thFilter":_vm.thFilter,"delete":_vm.deleteSkill,"create":_vm.createSkill,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }